var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7015 2.27873C4.78102 2.27873 4.03483 3.02492 4.03483 3.94539V17.2787C4.03483 18.1992 4.78102 18.9454 5.7015 18.9454H15.7015C16.622 18.9454 17.3682 18.1992 17.3682 17.2787V11.6827C17.3682 11.4762 17.3586 11.2706 17.3396 11.0666C17.1571 9.86561 16.1201 8.94539 14.8682 8.94539H13.1357C11.9851 8.94539 11.0524 8.01265 11.0524 6.86206V4.77873C11.0524 3.48247 10.0658 2.41663 8.80261 2.29109C8.66781 2.28288 8.53236 2.27873 8.39644 2.27873H5.7015ZM5.7015 0.612061H8.55237C8.68219 0.612061 8.81062 0.617997 8.9374 0.629614C11.1942 0.776274 13.304 1.83585 14.7707 3.5776L17.0758 6.31486C18.1639 7.60707 18.8295 9.19414 18.9944 10.8627C19.0211 11.0531 19.0348 11.2476 19.0348 11.4454V17.2787C19.0348 19.1197 17.5424 20.6121 15.7015 20.6121H5.7015C3.86055 20.6121 2.36816 19.1197 2.36816 17.2787V3.94539C2.36816 2.10444 3.86055 0.612061 5.7015 0.612061ZM15.7958 7.38237L13.4958 4.65116C13.222 4.326 12.9202 4.03056 12.5954 3.76719C12.6762 4.09103 12.719 4.42988 12.719 4.77873V6.86206C12.719 7.09218 12.9056 7.27873 13.1357 7.27873H14.8682C15.187 7.27873 15.4975 7.31454 15.7958 7.38237Z",
    fill: "#CA2867"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvIc);
export default __webpack_public_path__ + "static/media/csv_ic.1422bf8c8ed1a6affa4e751dfdb5964c.svg";
export { ForwardRef as ReactComponent };